// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-method-container .current-payment-method .card img {\n  width: 64px;\n}\n.payment-method-container .current-payment-method .paypal img {\n  width: 100px;\n}\n.ant-card-body .payment-method-container .ant-card .ant-card-body {\n  padding: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
